import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const Dashboard = () => {
  const [logs, setLogs] = useState([]);
  const [clickedLogs, setClickedLogs] = useState(() => {
    const stored = localStorage.getItem('clickedLogs');
    return stored ? JSON.parse(stored) : [];
  });
  const [selectedLog, setSelectedLog] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [staffList, setStaffList] = useState([]);

  useEffect(() => {
    fetchLogs();
    fetchStaffList();
    const interval = setInterval(fetchLogs, 30000); // Auto-refresh every 30s
    return () => clearInterval(interval);
  }, []);

  const fetchLogs = () => {
    fetch('https://pbhrm.com/api/logs')
      .then(res => res.json())
      .then(data => data.status === 1 && setLogs(data.data))
      .catch(err => console.error('Logs error:', err));
  };

  const fetchStaffList = () => {
    fetch('https://pbhrm.com/api/staff')
      .then(res => res.json())
      .then(data => data.status === 1 && setStaffList(data.data))
      .catch(err => console.error('Staff fetch error:', err));
  };

  const getStaffNameById = (id) => {
    const staff = staffList.find(s => s.id === parseInt(id));
    return staff ? staff.name : id;
  };

  const handleRowClick = (log) => {
    // Add to clicked logs if not already clicked
    if (!clickedLogs.includes(log.id)) {
      const updated = [...clickedLogs, log.id];
      setClickedLogs(updated);
      localStorage.setItem('clickedLogs', JSON.stringify(updated));
    }
    
    // Show the modal with log details
    setSelectedLog(log);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  // Filter out logs that have been clicked
  const getUnclickedLogs = () => {
    return logs.filter(log => !clickedLogs.includes(log.id));
  };

  const getModuleName = (module) => {
    const modules = {
      1: "Watchman", 2: "Plating Work", 3: "Task", 4: "VPP", 5: "IN", 6: "OUT",
      7: "Bazar", 8: "Parcel", 9: "Bill Module", 10: "Order", 11: "Cancel Order", 12: "Deliver Order"
    };
    return modules[module] || "Unknown";
  };

  const getActionType = (type) => {
    switch (type) {
      case 1: return "Add";
      case 2: return "Edit";
      case 3: return "Status Change";
      default: return "Unknown";
    }
  };

  const getBaseUrl = (module) => {
    switch (module) {
      case 9: return "https://pbhrm.com/uploads/billmodules/";
      case 7: return "https://pbhrm.com/uploads/bazarworks/";
      case 8: return "https://pbhrm.com/uploads/parcel/";
      default: return "https://pbhrm.com/uploads/default/";
    }
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? '' : d.toLocaleString();
  };

  const renderLogDetails = (log) => {
    const data = log.data || {};
    const baseUrl = getBaseUrl(log.module);

    return (
      <table className="table table-bordered">
        <tbody>
          {Object.entries(data).map(([key, value]) => {
            if (key === 'staff_id') {
              return (
                <tr key={key}>
                  <th>Staff Name</th>
                  <td>{getStaffNameById(value)}</td>
                </tr>
              );
            }

            if (key.toLowerCase() === 'image' || key.toLowerCase() === 'images') {
              if (typeof value === 'string') {
                const imgUrl = baseUrl + value.replace(/^\/+/, '');
                return (
                  <tr key={key}>
                    <th>{key}</th>
                    <td>
                      <img
                        src={imgUrl}
                        alt=""
                        style={{ height: 100, width: 100, objectFit: 'cover' }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = 'https://dummyimage.com/100x100/cccccc/000000&text=No+Image';
                        }}
                      />
                    </td>
                  </tr>
                );
              } else if (Array.isArray(value)) {
                return (
                  <tr key={key}>
                    <th>{key}</th>
                    <td style={{ display: 'flex', flexWrap: 'wrap' }}>
                      {value.map((img, i) => {
                        const imgUrl = baseUrl + img.replace(/^\/+/, '');
                        return (
                          <img
                            key={i}
                            src={imgUrl}
                            alt=""
                            style={{ height: 100, width: 100, objectFit: 'cover', margin: 5 }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = 'https://dummyimage.com/100x100/cccccc/000000&text=No+Image';
                            }}
                          />
                        );
                      })}
                    </td>
                  </tr>
                );
              }
            }

            return (
              <tr key={key}>
                <th>{key}</th>
                <td>{value !== null && value !== undefined ? value.toString() : ''}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  const unclickedLogs = getUnclickedLogs();

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <h3>Dashboard Logs</h3>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4>Activity Logs</h4>
                {clickedLogs.length > 0 && (
                  <small className="text-muted ms-3">
                    ({clickedLogs.length} log{clickedLogs.length !== 1 ? 's' : ''} viewed and hidden)
                  </small>
                )}
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Module</th>
                        <th>Action</th>
                        <th>Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {unclickedLogs.length > 0 ? (
                        unclickedLogs.map((log, index) => (
                          <tr
                            key={log.id}
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleRowClick(log)}
                          >
                            <td>{index + 1}</td>
                            <td>{getModuleName(log.module)}</td>
                            <td>{getActionType(log.type)}</td>
                            <td>{formatDate(log.time)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            {logs.length > 0 
                              ? "All logs have been viewed. New logs will appear here when available." 
                              : "No logs found"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal show={showModal} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Log Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedLog ? renderLogDetails(selectedLog) : <p>No details available</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Dashboard;